import { SVGProps } from 'react'

export interface TimerProps {
  enabled?: boolean
  durationInSec?: number
  durationInSeconds?: number
}

export interface RefreshProps {
  enabled?: boolean
  shouldRefresh?: boolean
  refreshIntervalInSec?: number
}

export interface LoadingScreenProps {
  title?: string
  description?: string
  subTitle?: string
  timer?: TimerProps
  refresh?: RefreshProps
  onTimerEnd?: () => void
  statusScreenProps?: any
}

export interface ProductSelectionProps {
  layout: {
    title: string
    products: Array<{
      title: string
      productImageUrl: string
      salientFeatures: ProductSelectionSalientItem[]
      keyBenefits: { title: string; items: IKeyBenefitItem[] }
      additionalBenefits: {
        title: string
        types: MoreBenefits[]
      }
      tnc: {
        title: string
        content: string[]
      }
      id: string
      productCode: string
    }>
  }
}

export interface ReadMoreState {
  welcome_benefits: boolean
  dining: boolean
  travel: boolean
  additional_benefits: number[]
}

export interface MoreBenefits {
  items: string[]
  title: string
}
export interface ProductSelectionSalientItem {
  title: string
  description: string
  subtext?: string
  icon: string
}

export interface IKeyBenefitItem {
  title: string
  description: string
  icon: string
}

export const enum loanType {
  homeLoan = 'homeLoan',
  personalLoan = 'personalLoan',
}

export interface LoanApplicationDetailsScreenProps {
  type: loanType.homeLoan | loanType.personalLoan
  title: string
  steps: Array<string>
  privacyNote: {
    title: string
    pcNotes: Array<{
      prefix: string
      text: string
      link?: string
    }>
  }
  guideLines: {
    title: string
    guideLinesList: Array<{
      Icon: React.FC<SVGProps<SVGSVGElement>>
      text: string
    }>
  }
  btn: {
    title: string
  }
}

export interface UploadLoanDocumentToS3Props {
  file: any
  customerId: number
  onecode: string
  ocFieldCode: string
  partnerId: number
  fileName: string
  uploadProgress?: (e: number) => void
}

export interface UserDetailsProps {
  customerId: number
  onecode: string
  partnerId: number
  leadSource?: string
}

export type FieldOption = {
  optionId: string
  optionValue: string
  orderNo: number
}

export type Field = {
  id: string
  name: string
  type: 'text' | 'phoneNumber' | 'select' | 'pincode'
  code: string
  ocFieldCode: string
  placeholder?: string
  rules: { required: boolean }[]
  config: { required: boolean }
  fieldOptions?: FieldOption[]
}

export type GroupedFields = {
  [key: string]: Field[]
}
